module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" N° de Solicitud: " + _vm._s(_vm.tramite.id) + "\n      "), _c('div', {
    staticClass: "tramite-estado"
  }, [(_vm.tramite.documento_derivar === 'CANCILLERIA') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": 'info',
      "text-color": "white"
    }
  }, [_c('small', [_vm._v("ENVIADO DESDE SERVICIO WEB")])]) : _vm._e(), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "color": _vm.estados[_vm.tramite.estado],
      "text-color": "white"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.tramite.estado ? _vm.tramite.estado.replace(/_/gi, ' ') : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('detalle-doc', {
    attrs: {
      "solicitud": _vm.tramite,
      "pagos": _vm.pagos
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-tooltip', {
    staticClass: "margin-0",
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalles = !_vm.detalles
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.detalles ? 'chevron_left' : 'chevron_right'))]), _vm._v("\n                " + _vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + "\n              ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + " detalles")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo > 1),
      expression: "tramite.id_archivo > 1"
    }],
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cambiarDoc()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("swap_horiz")]), _vm._v("\n                Cambiar\n              ")], 1), _vm._v(" "), _c('span', [_vm._v("Cambiar por otro documento")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo == 1 && _vm.$store.state.archivo > 1),
      expression: "tramite.id_archivo == 1 && $store.state.archivo > 1"
    }],
    staticClass: "margin-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelarCambio()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v("\n              Cancelar cambio\n            ")], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [(_vm.$store.state.permissions['tramitesDoc:update'] && _vm.tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR') ? _c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openObservar(_vm.solicitud)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" OBSERVAR\n              ")], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Observar documento")])], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 && _vm.tramite.id_archivo != null && _vm.tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR') ? _c('v-btn', {
    staticClass: "m-r-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.tramite.id_archivo == 1
    },
    on: {
      "click": function($event) {
        return _vm.aprobarEntidad(_vm.tramite);
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Enviar para firma (Entidad)\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 3 && _vm.tramite.id_archivo != null && _vm.tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR' && _vm.pdfValido === true) ? _c('v-btn', {
    staticClass: "m-r-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.tramite.id_archivo == 1
    },
    on: {
      "click": function($event) {
        return _vm.aprobarCancilleria(_vm.tramite);
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Enviar para firma\n            ")], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) && _vm.solicitud.firmante && _vm.solicitud.firmante.firmante_nombre_completo) ? _c('v-layout', {
    staticClass: "firma-detalle",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos del usuario")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_nombre_completo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_cargo || '[no registrado]') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Entidad:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.entidad_nombre)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Departamento:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_departamento.split(',').join(', ')) + "\n            ")]), _vm._v(" "), (_vm.solicitud.firmante.certicado_token) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firma en documento")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunSubject) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Certificado por:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunIssuer) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha inicio validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.inicioValidez) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha fin validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.finValidez) + " "), _c('br')]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 || _vm.$store.state.user.id_rol === 3) ? _c('div', [(_vm.tramite.id_archivo == 1) ? _c('file-upload', {
    attrs: {
      "url": _vm.url,
      "max-filesize": _vm.$store.state.maxFilesize,
      "label": "Arrastre aquí el documento o haga clic aquí para adjuntar el documento PDF para apostillar"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [(_vm.pdfValido == false && _vm.tramite.id_archivo > 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              El documento PDF, no es válido o se encuentra corrupto.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('pdf-view', {
    attrs: {
      "data": _vm.pdf,
      "url": _vm.urlPdf,
      "valido": _vm.validarPdf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.solicitud.estado.indexOf('OBSERVADO') != -1 && _vm.tramite.id_archivo == 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              La solicitud no cuenta con un documento PDF adjunto\n            ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    model: {
      value: (_vm.$store.state.modal5),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal5", $$v)
      },
      expression: "$store.state.modal5"
    }
  }, [(_vm.solicitud) ? _c('observar', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c29f380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/Revisor.vue
// module id = 526
// module chunks = 2